import { connect } from 'react-redux'
import Pupil from './pupil'
import { withRouter } from 'react-router-dom'
import { fetchPupil } from '../../../stores/pupil/pupil.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapDispatchToProps = (dispatch, { match }) => ({
  onMount: () => dispatch(fetchPupil(match.params.pupilId)).catch(errorHandler)
})

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(Pupil)
)
